import { FunctionComponent } from 'react';
import { useNavigate } from 'react-router-dom';
import { Link } from '@atoms/*';
import {
  ReportStatusBadge,
  type ReportStatusColor,
} from '../../atoms/ReportStatusBadge/ReportStatusBadge';
import { ContentCard } from '../../atoms/ContentCard/ContentCard';

export interface ReportCardProps {
  id: string;
  title: string;
  caseReference: string;
  dateCreated: string;
  dateUpdated: string;
  status: string;
  colors: Record<string, ReportStatusColor>;
  hideLink?: boolean;
  previousPath?: string;
}

export const ReportCard: FunctionComponent<ReportCardProps> = ({
  id,
  title,
  caseReference,
  dateCreated,
  dateUpdated,
  status,
  colors,
  hideLink = false,
  previousPath,
}) => {
  const navigate = useNavigate();

  const handleViewReport = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    navigate(`/report/${id}`, {
      state: {
        report: { id, title, caseReference, dateCreated, dateUpdated, status },
        previousPath,
      },
    });
  };

  return (
    <ContentCard className="border-b-brand-secondary border-b-4" padding="p-3">
      <h3 className="text-action-link mb-1 text-2xl font-bold">{title}</h3>
      <dl className="text-body mb-2 grid grid-cols-2 font-bold">
        <dt className="text-text-body">Case reference number</dt>
        <dd className="text-text-body text-right font-normal">
          {caseReference}
        </dd>
        <dt className="text-text-body">Date created</dt>
        <dd className="text-text-body text-right font-normal">{dateCreated}</dd>
        <dt className="text-text-body">Date updated</dt>
        <dd className="text-text-body text-right font-normal">{dateUpdated}</dd>
      </dl>
      <div
        className={`flex items-center ${hideLink ? 'justify-end' : 'justify-between'}`}
      >
        {!hideLink && (
          <Link
            linkType="inline"
            onClick={handleViewReport}
            className="text-body underline-offset-2"
          >
            View report progress
          </Link>
        )}
        <ReportStatusBadge status={status} colors={colors} />
      </div>
    </ContentCard>
  );
};
